import { getB2BTokens } from "../AuthService/userData";

const getTenantByPayerName = (payerName) => {
  let returnedTenant = getB2BTokens().find(
    (tenant) => tenant.payerName === payerName
  );


  console.log(returnedTenant);
  return returnedTenant;
};

export default getTenantByPayerName;
